import { ROUTES } from "@nf/constants";
import { LinkWithLocale } from "components";
import { useTranslation } from "next-i18next";
import { Trans } from "react-i18next";

import styles from "../ChooseSubscription/ChooseSubscription.module.scss";

export const VoucherLink = () => {
  const { t } = useTranslation("translations");

  return (
    <LinkWithLocale href={ROUTES.PAYMENT_VOUCHER}>
      <a>
        <span className={styles.subtitle}>
          <Trans
            t={t}
            i18nKey={"web_offer_voucher_header"}
            components={{
              bold: <span />,
            }}
          />
        </span>
      </a>
    </LinkWithLocale>
  );
};
